<template>
    <div>        
        <rotinastarefa :optarefacmp="optarefa" :idtarefacmp="idtarefa"></rotinastarefa>
        <div class="container-fluid" style="margin-top: -15px;">
            <div class="row">
                <div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-6">
                    <h5 style="color: #666666; margin-top: 5px; margin-bottom: 0px;">Dashboard</h5>                    
                </div>
                <div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                    <span class="tit-card-dash" style="float: right; font-weight: 500!important; font-size: 12px!important; margin-top: 7px;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                </div> 
                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-2">
                    <div class="dropdown">
                        <button type="button" class="btn btn-light btn-sm btn-block" data-toggle="modal" data-target="#mddefinirperiododash">
                            <i class="fa fa-calendar"></i> Selecionar Período
                        </button>                        
                    </div>
                </div>                
            </div>
            <div v-show="isloading" class="row">
                   <dashboard_skeleton></dashboard_skeleton>
            </div>
          
            <div v-show="!isloading" class="row">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                    <div class="row">
                        <div v-show="parseInt(usuariologado.cardresumopedidos) === 1" class="col-md-12">
                            <div class="card">
                                <div class="card-header card-dash">
                                    <span class="tit-card-dash">Resumo dos pedidos</span>
                                    <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                                </div>
                                <div class="card-body" style="min-height: 108px;">
                                    <div class="row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" style="padding-right: 0px;">
                                            <ul style="padding-left: 0px; margin-bottom: 0px; overflow:auto;">
                                                <li v-for="(item, indice) in lstresultadofaturamento" :key="indice" class="li-item-card-dash">
                                                    <span v-if="parseInt(item.stpedido) === 0" class="badge badge-primary badge-pill">
                                                        {{item.qtdpedidos}} {{ item.situacao }}
                                                    </span>
                                                    
                                                    <span v-else-if="parseInt(item.stpedido) === 1" class="badge badge-secondary badge-pill" style="background-color: #5A956A;">
                                                        {{item.qtdpedidos}} {{ item.situacao }}
                                                    </span>
                                                    
                                                    <span v-else class="badge badge-danger badge-pill">
                                                        {{item.qtdpedidos}} {{ item.situacao }}
                                                    </span>

                                                    
                                                    <span class="txt-item-card-dash" style="float: right;">
                                                        {{ mtdformatavalordecimal(parseFloat(item.totalpedidos)) }}
                                                    </span>
                                                </li>
                                                <li v-show="parseFloat(vtotalservicos) > 0" class="li-item-card-dash">
                                                    <span  class="badge badge-info badge-pill">
                                                        SERVIÇOS
                                                    </span>
                                                    <span  class="txt-item-card-dash" style="float: right;">
                                                        {{ mtdformatavalordecimal(parseFloat(vtotalservicos)) }}
                                                    </span>
                                                </li>
                                            </ul>                                    
                                        </div>

                                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                            <div class="row" style="margin-top: 8px;">
                                                <div class="col-md-12">
                                                    <h5 style="float: right; color: #5a956a; margin-bottom: 0px;">R$ {{ mtdformatavalordecimal(mediafaturamento) }}</h5>
                                                </div>

                                                <div class="col-md-12">
                                                    <h5 style="font-size: 12px; float: right;">MÉDIA FATURADA P/ PEDIDO</h5>
                                                    <br>

                                                    <!-- - Exibição da margem de lucro geral-->
                                                    <h5 style="font-size: 12px; float: right;">MARGEM DE LUCRO: <b>{{ this.margemlucrogeral }}%</b> </h5>
                                                    <br>

                                                    <i v-if="parseInt(qtdnotaspendentes) > 0"
                                                        style="font-size: 18px; cursor: pointer; margin-top: 12px;"
                                                        title="Há notas fiscais pendentes"
                                                        @click.prevent="$router.push({ name: 'cadnotasfiscais', params: { pendentes: 1 }})"
                                                        @mouseover="showpopover = true"
                                                        @mouseleave="hidepopover"
                                                        class="fa fa-exclamation-circle notasalert">
                                                    </i>
                                                    
                                                    
                                                    <div v-show="showpopover"
                                                        class="popover-container">
                                                        <div class="popover-content">
                                                            Há notas fiscais pendentes que precisam ser resolvidas. Clique aqui para gerenciá-las.
                                                        </div>
                                                            <div class="popover-arrow"></div>
                                                    </div>
                                                </div>                                
                                            </div>                                                                        
                                        </div>
                                    </div>
                                </div>
                            </div>                    
                        </div>
                        <div v-show="parseInt(usuariologado.cardfinanceiro) === 1" class="col-md-12" style="margin-top: 10px;">
                            <div class="card">
                                <div class="card-header card-dash">
                                    <span class="tit-card-dash">Demonstrativo financeiro</span>
                                    <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                                </div>
                                <div class="card-body" style="padding-bottom: 10px;">
                                    <div class="row">
                                        <div class="col-md-12" style="margin-top: -40px;">
                                            <graficopie  	:titulo="''"
                                                            :subtitulo="''"
                                                            :rotulo="'DETALHES:'"
                                                            :legendas="legendasfinanceiro"
                                                            :dados="dadosfinanceiro"
                                                            :visualizarlegenda="false"
                                                            :posicaolabel="'outside'"
                                            ></graficopie>
                                        </div>
                                        <div class="col-md-12">
                                            <ul style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px;">
                                                <li v-for="(item, indice) in dadosfinanceiro" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                    <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                    <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.media)) }}%)
                                                    </span>
                                                </li>
                                            </ul>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>                    
                        </div>                       
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                    <div class="row">
                        <div v-show="parseInt(usuariologado.cardtop5produtos) === 1" class="col-md-12">
                            <div class="card">
                                <div class="card-header card-dash">
                                    <button type="button" class="btn btn-secondary btn-muda-top5" @click.prevent="mtdmudatop5()" title="Alternar Valor/Quantidade"><i :class="parseInt(visualizartop5) === 0 ? 'fa fa-dollar' : 'fa fa-cubes'"></i></button>
                                    <span v-if="parseInt(visualizartop5) === 0" class="tit-card-dash">Top 5 produtos (valor)</span> 
                                    <span v-else class="tit-card-dash">Top 5 produtos (Quantidade)</span>                                     
                                    <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                                </div>
                                <div class="card-body" style="padding-top: 10px;min-height: 108px; padding-bottom: 0px;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <ul style="padding-left: 0px; margin-bottom: 0px; padding-bottom: 5px;">
                                                <li v-for="(item, indice) in lsttop5pro" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                    <div class="row">
                                                        <div class="col-8">
                                                            <h5 class="txt-item-card-dash-top5-desc" v-bind:title="item.descricao">{{ item.idproduto }} - {{ item.descricao }}</h5>
                                                        </div>
                                                        <div class="col-4 text-right valconainer">
                                                            <template v-if="parseInt(visualizartop5) === 0">
                                                                <h5 class="txt-item-card-dash-top5-val">{{ mtdformatavalordecimal(parseFloat(item.totalitem)) }} ({{ mtdformatavalordecimal(parseFloat(item.totalitem) / parseFloat(item.totalgeralvendas) * 100, '') }}%)</h5>
                                                            </template>
                                                            <template v-else>
                                                                <h5 v-if="mtdisdecimal(parseFloat(item.qtditem))" class="txt-item-card-dash-top5-val" style="float: right;">{{ mtdformataqtddecimal(parseFloat(item.qtditem)) }} ({{ mtdformatavalordecimal(parseFloat(parseFloat(item.qtditem)) / parseFloat(item.qtdgeralvendas) * 100, '') }}%)</h5>
                                                                <h5 v-else class="txt-item-card-dash-top5-val" style="float: right;">{{ item.qtditem }} ({{ mtdformatavalordecimal(parseFloat(item.qtditem) / parseFloat(item.qtdgeralvendas) * 100, '') }}%)</h5>                                                        
                                                            </template>
                                                        </div>
                                                    </div>                                                    
                                                </li>
                                            </ul>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>                    
                        </div>
                        <div v-show="parseInt(usuariologado.cardvendedores) === 1" class="col-md-12" style="margin-top: 10px;">
                            <div class="card">
                                <div class="card-header card-dash">
                                    <span class="tit-card-dash">Demonstrativo vendedores</span>
                                    <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                                </div>
                                <div class="card-body" style="padding-bottom: 10px;">
                                    <div class="row">
                                        <div class="col-md-12" style="margin-top: -40px;">
                                            <graficodoughnut :rotulo="'DETALHES:'"
                                                                :legendas="legendasvendedores"
                                                                :dados="dadosvendedores"
                                            ></graficodoughnut>
                                        </div>
                                        <div class="col-md-12">
                                            <ul style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 61px; overflow:auto;">
                                                <li v-for="(item, indice) in dadosvendedores" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                    <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                    <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(item.totalgeralvendas) * 100, '') }}%)
                                                    </span>
                                                </li>
                                            </ul>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>                    
                        </div>                        
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-body card-tarefas">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <div class="row">
                                                <div class="col-md-12 text-center" style="padding-top: 15px;">
                                                    <span style="color: white; font-size: 18px;">Melhore seu <strong>desempenho</strong> gerênciando suas <strong>tarefas</strong>!</span>                                                    
                                                </div>               
                                            </div>
                                        </div>
                                        <div class="col-md-4 text-center" style="margin-top: 25px;">
                                            <i class="fa fa-tasks" style="color: white; font-size: 38px;"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>                    
                        </div>
                        <div class="col-md-12" style="margin-top: 10px;">
                            <div class="card">
                                <div class="card-header card-dash" style="padding-top: 7px!important; padding-bottom: 7px!important;">
                                    <div class="row">
                                        <div class="col-5 col-sm-5 col-md-4" style="margin-top: 5px!important;">
                                            <span class="tit-card-dash">Minhas tarefas</span>
                                        </div>
                                        <div class="col-7 col-sm-7 col-md-8 col-lg-8 text-right">
                                            <select name="sbsituacaotarefas" class="form-control form-control-sm selectpicker" id="sbsituacaotarefas" @change="mtdresultadofaturamento()" multiple data-actions-box="true">
                                                <option data-content="<span class='badge badge-primary bdg-digitacao bgd-st-tarefa'>Em dia</span>" value="0"></option>
                                                <option data-content="<span class='badge badge-primary bdg-enviada bgd-st-tarefa'>Atrasadas</span>" value="2"></option>
                                                <option data-content="<span class='badge badge-primary bdg-autorizada bgd-st-tarefa'>Finalizadas</span>" value="1"></option>
                                            </select>
                                        </div>                                        
                                    </div>
                                </div>
                                <div class="card-body" style="background: #f8f9fc26; padding-top: 0px; padding-bottom: 18px; height: 310px; overflow:auto;">
                                    <div class="row">
                                        <div v-show="lsttarefas.length > 0" class="col-md-12">
                                            <div v-for="(tarefa, indice) in lsttarefas" :key="indice" class="card card-tarefa" style="margin-top: 15px;" @click.prevent="mtdgerenciartarefa(tarefa.id)">
                                                <div class="card-body" style="padding: 10px;">
                                                    <div class="row">
                                                        <div class="col-12" style="margin-bottom: 15px;">
                                                            <template v-if="parseInt(tarefa.sttarefa) === 1">
                                                                <span class="span-status-tarefa tarefa-finalizada text-center" title="Tarefa finalizada">
                                                                    <i class="fa fa-calendar-check-o icone-status-tarefa"></i>
                                                                </span>
                                                            </template>
                                                            <template v-else-if="parseInt(tarefa.sttarefa) === 0 && mtddatatarefamenor(tarefa.dtvisualizar)">
                                                                <span class="span-status-tarefa tarefa-normal text-center" title="Tarefa em dia">
                                                                    <i class="fa fa-lightbulb-o icone-status-tarefa"></i>
                                                                </span>                                                                
                                                            </template>
                                                            <template v-else>
                                                                <span class="span-status-tarefa tarefa-atrasada text-center" title="Tarefa atrasada">
                                                                    <i class="fa fa-clock-o icone-status-tarefa"></i>
                                                                </span>                                                                
                                                            </template>                                                            
                                                            <h5 class="tit-tarefa" v-bind:title="tarefa.titulo">{{ tarefa.titulo }}</h5>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="dv-cal"><i class="fa fa-calendar" style="font-size: 12px; color: #aaaaaa;"></i></div>
                                                            <span class="tit-data">{{ mtdformadardataextenso(mtdtransformadata(tarefa.dtvisualizar+'T00:00:00')) }}</span>
                                                        </div>
                                                        <div class="col-12 text-right" style="margin-top: 8px;">
                                                            <div v-if="tarefa.checklist.length > 0" class="progress">
                                                                <div class="progress-bar pb-tarefa" v-bind:style="{width: tarefa.concluida + '%'}" title="Percentual de conclusão baseado na checklist">{{ tarefa.concluida }}%</div>
                                                            </div>                                                            
                                                        </div>                                                        
                                                        <div class="col-12 text-right" style="margin-top: 8px;">
                                                            <template v-for="(participante, indicep) in tarefa.participantes">
                                                                <img v-if="parseInt(participante.marcado) === 1" :key="indicep" v-bind:src="pathfotos+participante.foto" class="img-usutarefa" data-toggle="tooltip" v-bind:title="participante.nomeusu">
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>                                             
                                        </div>
                                        <button type="button" class="btn btn-primary btn-purple" id="btnovatarefa" title="Adicionar nova tarefa" @click.prevent="mtdnovatarefa()"><i class="fa fa-plus"></i></button>                                        
                                    </div>                                    
                                </div>
                            </div>                    
                        </div>                        
                    </div>    
                </div>

                <div v-show="parseInt(usuariologado.cardcompra) === 1" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                    <div class="row">                   
                        <div  class="col-md-12" style="margin-top: 5px; margin-bottom: 15px;">
                            <div class="card">
                                <div class="card-header card-dash">
                                    <span class="tit-card-dash">Demonstrativos de compras</span>
                                    <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                                </div>
                                <div class="card-body" style="padding-bottom: 10px;">
                                    <div class="row">
                                        <div class="col-md-12" style="margin-top: -40px;">
                                            <graficopie  	:titulo="''"
                                                            :subtitulo="''"
                                                            :rotulo="'DETALHES:'"
                                                            :legendas="legendapedcompra"
                                                            :dados="dadospedcompra"
                                                            :visualizarlegenda="false"
                                                            :posicaolabel="'outside'"
                                            ></graficopie>
                                        </div>
                                        <div class="col-md-12">
                                            <ul style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px;">
                                                <li v-for="(item, indice) in dadospedcompra" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                    <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                    <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.media)) }}%)
                                                    </span>
                                                </li>
                                                <li class="li-item-card-dash" style="height: 15px;">
                                                    <span class=""><b>TOTAL COMPRAS</b></span>
                                                    <span class="" style="float: right;"><b>{{mtdformatavalordecimal(parseFloat(totalpedcompra))}}</b></span>
                                                </li>    
                                            </ul>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>                    
                        </div>  
                    </div>    
                </div>

                <div v-show="parseInt(usuariologado.cardpicovendas) === 1" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                    <div class="row">
                        <div class="col-md-12" style="margin-top: 10px;">
                            <div class="card">
                                <div class="card-header card-dash">
                                    <span class="tit-card-dash">Picos de venda mais intenso <span style="color: #0acf97; font-weight: bold;">{{ hrmaior }}:00</span>.</span>
                                    <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                                </div>
                                <div class="card-body" style="padding-bottom: 10px;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <ul class="lista-dia-semana-dash text-center">
                                                <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 2 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(2)">SEG</li>
                                                <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 3 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(3)">TER</li>
                                                <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 4 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(4)">QUA</li>
                                                <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 5 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(5)">QUI</li>
                                                <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 6 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(6)">SEX</li>
                                                <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 7 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(7)">SAB</li>
                                                <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 1 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(1)">DOM</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12">
                                            <graficobarra :titulo="''"
                                                            :agrupamento="agrupamentohoras"
                                                            :series="agrupamentoquantidades"
                                            ></graficobarra>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>                    
                        </div>
                    </div>
                </div>

                <!-- - Adição do componente gráfico de meta do vendedor principal-->
                <div v-show="parseInt(usuariologado.cardmetaindividual) === 1" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                    <div class="row">                   
                        <div  class="col-md-12" style="margin-top: 5px; margin-bottom: 15px;">
                            <!-- - "Velocímetro" com o cumprimento da meta do vendedor padrão-->
                            <div class="card">
                                <div class="card-header card-dash">
                                    <span class="tit-card-dash">Meta individual</span>
                                    <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;">
                                        <i class="fa fa-calendar"></i> {{ displayperiodo }} 
                                    </span>
                                </div>
                                <div class="card-body" style="padding-bottom: 10px;">
                                    <div class="row">
                                        <div class="col-md-12" style="margin-top: -40px; height: 200px;">
                                            <graficohalfdoughnut    :rotulo="'DETALHES:'"
                                                                    :legendas="legendasmetavendedorpadrao"
                                                                    :dados="dadosmetavendedorpadrao"
                                            ></graficohalfdoughnut>
                                        </div>
                                    </div>
                                </div>
                            </div>  
                            
                            <!-- - Exibição dos top5 produtos mais vendidos pelo vendedor padrão-->
                            <div class="card" style="margin-top: 10px;">
                                <div class="card-header card-dash">
                                    <button type="button" class="btn btn-secondary btn-muda-top5" @click.prevent="mtdmudatop5vendedoradrao()" title="Alternar Valor/Quantidade"><i :class="parseInt(visualizartop5vendedorpadrao) === 0 ? 'fa fa-dollar' : 'fa fa-cubes'"></i></button>
                                    <span v-if="parseInt(visualizartop5vendedorpadrao) === 0" class="tit-card-dash">Meus top 5 produtos (valor)</span> 
                                    <span v-else class="tit-card-dash">Meus top 5 produtos (Quantidade)</span>                                     
                                    <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                                </div>
                                <div class="card-body" style="padding-top: 10px;min-height: 108px; padding-bottom: 0px;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <ul style="padding-left: 0px; margin-bottom: 0px; padding-bottom: 5px;">
                                                <li v-for="(item, indice) in lsttop5provendedorpadrao" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                    <div class="row">
                                                        <div class="col-8">
                                                            <h5 class="txt-item-card-dash-top5-desc" v-bind:title="item.descricao">{{ item.idproduto }} - {{ item.descricao }}</h5>
                                                        </div>
                                                        <div class="col-4 text-right valconainer">
                                                            <template v-if="parseInt(visualizartop5vendedorpadrao) === 0">
                                                                <h5 class="txt-item-card-dash-top5-val">{{ mtdformatavalordecimal(parseFloat(item.totalitem)) }} ({{ mtdformatavalordecimal(parseFloat(item.totalitem) / parseFloat(item.totalgeralvendas) * 100, '') }}%)</h5>
                                                            </template>
                                                            <template v-else>
                                                                <h5 v-if="mtdisdecimal(parseFloat(item.qtditem))" class="txt-item-card-dash-top5-val" style="float: right;">{{ mtdformataqtddecimal(parseFloat(item.qtditem)) }} ({{ mtdformatavalordecimal(parseFloat(parseFloat(item.qtditem)) / parseFloat(item.qtdgeralvendas) * 100, '') }}%)</h5>
                                                                <h5 v-else class="txt-item-card-dash-top5-val" style="float: right;">{{ item.qtditem }} ({{ mtdformatavalordecimal(parseFloat(item.qtditem) / parseFloat(item.qtdgeralvendas) * 100, '') }}%)</h5>                                                        
                                                            </template>
                                                        </div>
                                                    </div>                                                    
                                                </li>
                                            </ul>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>  
                    </div>    
                </div>

                <!-- - Adição do componente gráfico de meta de técnicos-->
                <div v-show="parseInt(usuariologado.carddemotecnico) === 1" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                    <div class="card">
                        <!-- - Cabeçalho do gráfico de técnico de metas-->
                        <div class="card-header card-dash">
                            <span class="tit-card-dash">Demonstrativo técnicos</span>
                            <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                        </div>

                        <!-- - Exibição do gráfico-->
                        <div class="card-body" style="padding-bottom: 10px;">
                            <div class="row">
                                <div class="col-md-12" style="margin-top: -40px;">
                                    <graficodoughnut :rotulo="'DETALHES:'"
                                                        :legendas="legendastecnicos"
                                                        :dados="dadostecnicos"
                                    ></graficodoughnut>
                                </div>

                                <!-- - Exibição dos técnicos e seus dados-->
                                <div class="col-md-12">
                                    <ul style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 61px; overflow:auto;">
                                        <li v-for="(item, indice) in dadostecnicos" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                            <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                            <span class="txt-item-card-dash-grafico" style="float: right;">
                                                {{ mtdformatavalordecimal(parseFloat(item.value)) }}
                                            </span>
                                        </li>
                                    </ul>                                            
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>
                <!-- - Adição do componente do top 10 giro de produto-->
                <div v-show="parseInt(usuariologado.cardgiroproduto) === 1" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                    <div class="card">
                        <!-- - Cabeçalho do gráfico de técnico de metas-->
                        <div class="card-header card-dash">
                            <span class="tit-card-dash">Top 10 giro de produtos</span>
                            <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                        </div>

                        <div class="card-body" style="padding-top: 10px;min-height: 108px; padding-bottom: 0px;">
                            <div class="row">
                                <div class="col-md-12">
                                    <ul style="padding-left: 0px; margin-bottom: 0px; padding-bottom: 5px;">
                                        <li v-for="(item, indice) in lsttop10pro" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                            <div class="row">
                                                <div class="col-8">
                                                    <h5 class="txt-item-card-dash-top10-desc" v-bind:title="item.descricao">{{ item.idproduto }} - {{ item.descricao }}</h5>
                                                </div>
                                                <div class="col-4 text-right valconainer">
                                                    <template>
                                                        <h5 class="txt-item-card-dash-top10-val">{{ mtdformatavalordecimal(parseFloat(item.qtdentrada)) }} {{ mtdformatavalordecimal(parseFloat(item.qtdvenda)) }}({{ mtdformatavalordecimal(parseFloat(item.qtdvenda) / parseFloat(item.qtdentrada) * 100, '') }}%)</h5>
                                                    </template>
                                                </div>
                                            </div>                                                    
                                        </li>
                                    </ul>                                            
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>

                <div v-show="parseInt(usuariologado.cardmetas) === 1" class="col-md-12" style="margin-top: 10px;">
                    <div class="card">
                        <div class="card-header card-dash">
                            <span class="tit-card-dash">Metas de vendedores</span>
                            <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                        </div>
                        <div class="card-body" style="padding-bottom: 10px;">
                            <div class="row">
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <span class="lblselect2">Filial:</span>
                                    <select id="cbfilialmetas" data-placeholder="Selecione uma filial" v-model="idfilialmeta" data-allow-clear="true" style="width:100%;">
                                    </select>
                                </div>                                
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="edmesmeta">Mês:</label>
                                    <select id="edmesmeta" class="form-control form-control-sm" v-model="mesmeta" data-bv-group=".group">
                                        <option value="1">Janeiro</option>
                                        <option value="2">Fevereiro</option>
                                        <option value="3">Março</option>
                                        <option value="4">Abril</option>
                                        <option value="5">Maio</option>
                                        <option value="6">Junho</option>
                                        <option value="7">Julho</option>
                                        <option value="8">Agosto</option>
                                        <option value="9">Setembro</option>
                                        <option value="10">Outubro</option>
                                        <option value="11">Novembro</option>
                                        <option value="12">Dezembro</option>
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-1">
                                    <label for="edanometa">Ano:</label>
                                    <select name="edanometa" class="form-control form-control-sm" id="edanometa" v-model="anometa" style="text-align: right;">
                                        <option v-for="(ano, index) in anoslistameta" :key="index" :value="ano.ano">{{ ano.ano }}</option>
                                    </select>
                                </div>
                                <div class="col-sm-1 col-md-1 col-lg-1">
                                    <button type="button" class="btn btn-sm btn-secondary" @click.prevent="mtdmetasvendedores()" title="Atualizar" style="margin-top: 20px;"><i class="fa fa-refresh"></i></button>                                    
                                </div>                                                                                                                                
                            </div>
                            <div class="row"> 
                                <div class="col-md-12 grafico-metavendedores">
                                    <graficometavendedores :titulo="''" :agrupamento="gruponomes" :series="series"></graficometavendedores>                                  
                                </div>
                            </div>
                            <div class="row" style="margin-top:25px;">
                                <div class="col-md-12">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-sm table-hover" style="font-size: 12px;">
                                            <thead class="thead-light">
                                                <tr class="font-weight-bold">
                                                    <th>Vendedor</th>
                                                    <th>Meta</th>
                                                    <th>Vendas</th>
                                                    <th>Falta</th>
                                                    <th>Concluído</th>
                                                    <th>Sit.</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(meta, index) in dadosmetas" v-bind:key="index">
                                                    <td class="font-weight-bold">{{ meta.nome }}</td>
                                                    <td class="text-right font-weight-bold">{{ mtdformatavalordecimal(meta.totalmeta) }}</td>
                                                    <td class="text-right font-weight-bold">{{ mtdformatavalordecimal(meta.totalvendas) }}</td>
                                                    <td class="text-right font-weight-bold" v-bind:class="parseFloat(meta.totalmeta) < parseFloat(meta.totalvendas) ? 'text-verde': 'text-danger'">{{ mtdformatavalordecimal(meta.vlrestante) }}</td>
                                                    <td class="text-center font-weight-bold" v-bind:class="parseFloat(meta.totalmeta) < parseFloat(meta.totalvendas) ? 'text-verde': 'text-danger'">
                                                        <span title="Percentual concluído da meta">{{ meta.perc }}% </span>
                                                        <span v-if="parseFloat(meta.totalmeta) > parseFloat(meta.totalvendas)" class="text-center font-weight-bold text-alerta" title="Percentual que falta para bater a meta"> - {{ 100 - parseFloat(meta.perc) }}%</span>   
                                                    </td>                                                    
                                                    <td class="text-center">
                                                        <i v-if="parseFloat(meta.totalvendas) >= parseFloat(meta.totalmeta)" class="fa fa-check-circle" style="color: #0acf97; font-size: 18px;" title="Meta concluída"></i>                                                        
                                                        <i v-else class="fa fa-times-circle text-danger" style="font-size: 18px;" title="Meta NÃO concluída"></i>
                                                    </td>
                                                </tr>
                                                <tr >
                                                    <td class="font-weight-bold">TOTAL GERAL</td>
                                                    <td class="text-right font-weight-bold">{{ mtdformatavalordecimal(totalgeralmeta) }}</td>
                                                    <td class="text-right font-weight-bold">{{ mtdformatavalordecimal(totalgeralvendasmetas) }}</td>
                                                    <td class="text-right font-weight-bold" v-bind:class="parseFloat(totalgeralmeta) < parseFloat(totalgeralvendasmetas) ? 'text-verde': 'text-danger'">{{ mtdformatavalordecimal(totalgeralmeta - totalgeralvendasmetas) }}</td>
                                                    <td class="text-center font-weight-bold" v-bind:class="parseFloat(totalgeralmeta) < parseFloat(totalgeralvendasmetas) ? 'text-verde': 'text-danger'">
                                                        
                                                    </td>                                                    
                                                    <td class="text-center">
                                                        <i v-if="parseFloat(totalgeralvendasmetas) >= parseFloat(totalgeralmeta)" class="fa fa-check-circle" style="color: #0acf97; font-size: 18px;" title="Meta concluída"></i>                                                        
                                                        <i v-else class="fa fa-times-circle text-danger" style="font-size: 18px;" title="Meta GERAl NÃO concluída"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>                    
            </div>
          
        </div>
        <!-- Modal para definição do período para a dashboard -->
        <div class="modal fade" id="mddefinirperiododash" tabindex="-1" role="dialog" aria-labelledby="definirperiododashLabel" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="definirperiododashLabel"><i class="fa fa-calendar"></i> Definição de período</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">  
                            <div class="col-md-12 border-right nao-imprimir">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilial" data-placeholder="Selecione uma filial" v-model="lstfiliais" data-allow-clear="true" style="width:100%;">
                                </select>                        
                            </div>
                            <div class="col-md-12">
                                <label for="eddtini">De:</label>
                                <div class="input-group">
                                    <date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>								
                                </div>
                            </div>
                            <div class="col-md-12">
                                <label for="eddtfim">até:</label>
                                <div class="input-group">
                                    <date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>																			
                                </div>
                            </div>                   
                                       
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-green btn-sm" @click.prevent="mtdresultadofaturamento()" data-dismiss="modal"><i class="fa fa-check"></i> Aplicar período</button>
                    </div>
                </div>
            </div>
        </div>              
    </div>
</template>
<script>
import util from '../utilitarios/util.js';
import * as moment from 'moment';
import GraficoPie from '../components/cmpgraficopie.vue';
import GraficoDoughnut from '../components/cmpgraficodoughnut.vue';
import RotinasTarefa from '../components/cmprotinastarefa.vue';
import GraficoBarra from '../components/cmpgraficobarra.vue';
import GraficoMetaVendedores from '../components/cmpgraficometasvendedores.vue';
// - Importação do gráfico halfdonut para a exibição do cumprimento da meta do vendedor padrão
import GraficoHalfDoughnut from '../components/cmpgraficohalfdonut.vue';
import Skeletondashboard from '../components/cmpskeletondashboard.vue';

export default {
    name: 'principal',
		components: {
            'graficopie'		    : GraficoPie,
            'graficodoughnut'       : GraficoDoughnut,
            'graficobarra'          : GraficoBarra,
            'rotinastarefa'         : RotinasTarefa,
            'graficometavendedores' : GraficoMetaVendedores,
            // - Adição do novo componete de exibição de meta do vendedor principal
            'graficohalfdoughnut'   : GraficoHalfDoughnut,
            'dashboard_skeleton'   : Skeletondashboard
		},

		data: function() {
			return {   
                utodasfiliais 		    : this.$store.state.usuario.todasfiliais, 
                pathfotos               : this.$store.state.configpaths.pathimagens,
                patharquivos            : this.$store.state.configpaths.pathtarefas,//diretório dos arquivos das tarefas
                lstresultadofaturamento : [],

                // - Variáveis de margem de lucro geral
                // margemlucrogeral        : 0,

                // - Variáveis para meta do vendedor padrão
                legendasmetavendedorpadrao  : [],
                dadosmetavendedorpadrao     : [],

                mediafaturamento        : 0,
                displayperiodo          : '',
                legendasfinanceiro      : [],
                dadosfinanceiro         : [],
                legendasvendedores      : [],
                dadosvendedores         : [],
                dadospedcompra          : [],
                legendapedcompra        : [],

                agrupamentohoras        : [],
                agrupamentoquantidades  : [],
                hrmaior                 : 0,

                totalpedcompra          : 0,
                totalfin                : 0,
                visualizartop5          : 0,//0 - Valor, 1 - Quantidade
                qtdnotaspendentes       : 0,
                lsttop5pro              : [],
                lsttop5provl            : [],
                lsttop5proqtd           : [],
                lsttop10pro             : [],
                lsttarefas              : [],
                pdtini                  : moment().format('01/MM/YYYY'),
                pdtfim                  : moment().endOf('month').format('DD/MM/YYYY'),//moment().format('DD/MM/YYYY'),
                diaselecionado          : 1,
                lstfiliais              : [],

                //variáveis para manipulação das tarefas
                optarefa                : 0,
                idtarefa                : 0,
                showpopover             : false,

                //variáveis da meta
                idfilialmeta            : null,
                dadosmetas              : [],
                mesmeta                 : 1,
                anometa                 : 1,
                anoslistameta           : [],
                gruponomes              : [],
                series                  : [],
                totalgeralvendasmetas   : 0,
                totalgeralmeta          : 0,

                // - Variável de margem de lucro geral
                margemlucrogeral        : 0,
                vtotalservicos          : 0,

                // - Variáveis para top 5 produtos mais vendidos por vendedor padrão
                visualizartop5vendedorpadrao        : 0,
                lsttop5provlvendedorpadrao          : [],
                lsttop5provendedorpadrao            : [],
                lsttop5proqtdvendedorpadrao         : [],

                //skeleton 
                isloading                           : false,

                // - Permissão do usuário para visualizar dados do vendedor pardrão e meta
                usuarioPermissaoVendedorPadraoMetas : true,

                // - Variáveis para dados de técnicos
                legendastecnicos        : [],
                dadostecnicos           : [],

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                }                
            }
        },
		methods:{
            //  - Verificar a permissão de usuário para vendedor padrão metas #PERMISSÃO VENDEDOR PADRÃO META
            mtdpermissaovendedorpadraometas(){
                console.log("teste de permissão");
                if (util.opcaousuario("030Z.010Z.130Z", this.$store.state.perfilusuario)){
                    this.usuarioPermissaoVendedorPadraoMetas = true;
                } 
                else {
                    this.usuarioPermissaoVendedorPadraoMetas = false;
                }
            },

            // - Método para trocar a exibição dos dados de itens mais vendidos pelo vendedor padrão
            mtdmudatop5vendedoradrao(){
                this.visualizartop5vendedorpadrao = parseInt(this.visualizartop5vendedorpadrao) === 0 ? 1 : 0;
                this.lsttop5provendedorpadrao     = parseInt(this.visualizartop5vendedorpadrao) === 0 ? this.lsttop5provlvendedorpadrao : this.lsttop5proqtdvendedorpadrao;
            },

            // - Método para extrair informações do 
            //banco de dados referente a metas do vendedor padrão
            mtdvendedorpadraoinfo() {
            
                var vself = this;
                let parametros = [
                    {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},                    
                    {parametro: 'op',           valor : 'vendedorpadraometa'},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'dtinicio',     valor : vself.pdtini},
                    {parametro: 'dtfim',        valor : vself.pdtfim},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
                retorno.then(function (response) {
                    //Funções a serem feitas quando a requisição for bem sucedida
                    let vendedorMeta          = response.data[0];
                    let vendedorMetaAtingida  = response.data[1];
                    let vendedorMetaRestante  = vendedorMeta - vendedorMetaAtingida;
                    // window.alert(vendedorMeta);
                    // console.log(vendedorMeta);

                    if (vendedorMetaRestante < 0) {
                        vendedorMetaRestante = 0;
                    }
                    vself.dadosmetavendedorpadrao = [
                        {value: parseFloat(vendedorMetaAtingida)    , name: 'ATINGIDA'},
                        {value: parseFloat(vendedorMetaRestante)    , name: 'RESTANTE'}
                    ];
                    vself.legendasmetavendedorpadrao = util.gerardadoslegendagrafico(vself.legendasmetavendedorpadrao);
                }).catch(function (response) {
                });  
            },

            hidepopover() {
                setTimeout(() => {
                    this.showpopover = false;
                }, 200); 
            },
            mtdisdecimal(num){
                return util.isDecimal(num);
            },
            mtdformataqtddecimal(val){
                return util.formatavalordecimais(val ,3);
            },
            mtddatatarefamenor(datatarefa){
                return util.datamenor(datatarefa);
            },
            mtdformadardataextenso(data, mostrahr) {
                if (!mostrahr) {
                    return util.dataextenso(util.InverterData(data) + 'T00:00:00');
                }else{
                    let vdthr = data.split('T');
                    let vhr   = vdthr[1].split(':');
                    return util.dataextenso(util.InverterData(data) + 'T00:00:00')+' às '+vhr[0]+':'+vhr[1];
                }
            },
            mtdtransformadata: function(dttrasnf){
                return util.formatadatahrdb(dttrasnf);
            },                        
            mtdmesextenso(mes){
                switch (parseInt(mes)) {
                    case 1:
                        return 'JANEIRO'
                        break;
                    case 2:
                        return 'FEVEREIRO'
                        break;
                    case 3:
                        return 'MARÇO'
                        break;
                    case 4:
                        return 'ABRIL'
                        break;     
                    case 5:
                        return 'MAIO'
                        break;     
                    case 6:
                        return 'JUNHO'
                        break;     
                    case 7:
                        return 'JULHO'
                        break;                                                                                                                           
                    case 8:
                        return 'AGOSTO'
                        break;     
                    case 9:
                        return 'SETEMBRO'
                        break;     
                    case 10:
                        return 'OUTUBRO'
                        break;     
                    case 11:
                        return 'NOVEMBRO'
                        break;                                                                                 
                    case 12:
                        return 'DEZEMBRO'
                        break;                        
                }
            },
			mtdformatavalordecimal(valor){
				return util.formatarvalor(valor, '');
            },
            mtdmediafaturados(){
                let mediafat = 0;
                for (let i = 0; i < this.lstresultadofaturamento.length; i++) {                    
                    if (parseInt(this.lstresultadofaturamento[i].stpedido) === 1) {
                        mediafat = this.lstresultadofaturamento[i].totalpedidos / this.lstresultadofaturamento[i].qtdpedidos;
                    }                    
                }
                return mediafat;
            }, 
            mtdremoveatrasadas(){
                let tarefas = $('#sbsituacaotarefas').selectpicker('val');
                for (let i = 0; i < tarefas.length; i++) {
                    if (parseInt(tarefas[i]) === 2){
                        return false;
                    }                       
                }
                return true;
            },   
            mtdremoveemdia(){
                let tarefas = $('#sbsituacaotarefas').selectpicker('val');
                for (let i = 0; i < tarefas.length; i++) {
                    if (parseInt(tarefas[i]) === 0){
                        return false;
                    }                       
                }
                return true;
            },     
            mtdresultadofaturamentonew(){

            },            
            mtdresultadofaturamento(){
                var vself           = this;
                vself.pathfotos     = vself.$store.state.configpaths.pathimagens;
                // let loader          = vself.$loading.show();
                vself.isloading = true;
                let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                let filtrotarefas   = '';
                //let filtrotarefas   = ' and pt.idusuario='+vself.$store.state.usuario.id+' and t.dttarefa between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                if (vself.mtdremoveatrasadas()){
                    filtrotarefas   = ' and pt.idusuario='+vself.$store.state.usuario.id+' and t.sttarefa in ('+$('#sbsituacaotarefas').selectpicker('val')+')';                
                }else{
                    if ($('#sbsituacaotarefas').selectpicker('val').length > 0){
                        filtrotarefas   = ' and pt.idusuario='+vself.$store.state.usuario.id+' and t.sttarefa in ('+$('#sbsituacaotarefas').selectpicker('val')+', 0)';                
                    }else{
                        filtrotarefas   = ' and pt.idusuario='+vself.$store.state.usuario.id+' and t.sttarefa < 0';                                        
                    }
                }
                let parametros      = [
                    {parametro: 'idclientesac', valor  : window.localStorage.getItem('idcliente')},
                    {parametro: 'op',           valor : 'dash'},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                    
                    {parametro: 'periodo',      valor : periodo},
                    {parametro: 'usuariologado',valor : JSON.stringify(vself.usuariologado)},
                    {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
                    {parametro: 'diasemana',    valor : util.diasemanaintmysql()},
                    {parametro: 'filtrotarefas',valor : filtrotarefas},//' and t.sttarefa=0'},
                    {parametro: 'patharquivos', valor : vself.patharquivos},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
                retorno.then(function (response) {
                    vself.lstresultadofaturamento = response.data.mediafaturamento;
                    vself.lsttop5provl            = response.data.top5provl;
                    vself.lsttop5proqtd           = response.data.top5proqtd;
                    vself.lsttop5pro              = vself.lsttop5provl;
                    vself.qtdnotaspendentes       = parseInt(response.data.resultnotas)
                    vself.vtotalservicos          = response.data.totalservicos; 
                    vself.lsttop10pro             = response.data.top10giro;
                    
                    // - Atribuir os resultados da pesquisa na lista
                    vself.lsttop5provlvendedorpadrao    = response.data.top5provlvendedorpadrao;
                    vself.lsttop5proqtdvendedorpadrao   = response.data.top5proqtdvendedorpadrao;
                    vself.lsttop5provendedorpadrao      = vself.lsttop5provlvendedorpadrao;

                    vself.dadostecnicos = [];
                    response.data.tecnicos.forEach(element => {
                        console.log(element);
                        vself.dadostecnicos.push(
                            {value: parseFloat(element.valor_servico), name: element.nome, media: parseFloat(element.valor_servico)}
                        );
                    });
                    vself.legendastecnicos  = util.gerardadoslegendagrafico(vself.dadostecnicos);

                    // calculando margem de lucro geral - só é possivel chamar o calculo se a variavel estiver instanciada!!! - Guga

                    if(vself.lstresultadofaturamento.length > 0){
                        vself.mtdmargemlucrogeral();
                    }
                    
                    vself.mtdvendedorpadraoinfo();
            
                    if(parseInt(vself.qtdnotaspendentes)> 0){
                        vself.showpopover = true;
                        setTimeout(() => {
                            vself.showpopover = false;
                        }, 5000);
                    }

                    vself.lsttarefas              = [];
                    let lsttmp                    = JSON.parse(JSON.stringify(response.data.tarefas));
                    
                    if (vself.mtdremoveatrasadas()){
                        for (let x = 0; x < lsttmp.length; x++) {
                            if (parseInt(lsttmp[x].sttarefa) === 1){
                                vself.lsttarefas.push(lsttmp[x]);
                            }else if (parseInt(lsttmp[x].sttarefa) === 0 && vself.mtddatatarefamenor(lsttmp[x].dtvisualizar)){
                                vself.lsttarefas.push(lsttmp[x]);
                            }                            
                        }
                    }else{
                        vself.lsttarefas          = lsttmp;
                    }

                    if (vself.mtdremoveemdia()){
                        lsttmp           = JSON.parse(JSON.stringify(vself.lsttarefas));
                        vself.lsttarefas = [];

                        for (let x = 0; x < lsttmp.length; x++) {
                            if (parseInt(lsttmp[x].sttarefa) === 1){
                                vself.lsttarefas.push(lsttmp[x]);
                            }else if (parseInt(lsttmp[x].sttarefa) === 0 && !vself.mtddatatarefamenor(lsttmp[x].dtvisualizar)){
                                vself.lsttarefas.push(lsttmp[x]);
                            }                            
                        }
                    }                

                    vself.totalfin = parseFloat(response.data.areceber) + parseFloat(response.data.recebido) + parseFloat(response.data.apagar) + parseFloat(response.data.pago);
                    vself.dadosfinanceiro = [
                        {value: parseFloat(response.data.areceber), name: 'À RECEBER',  media : parseFloat(response.data.areceber) > 0 ? parseFloat(response.data.areceber) / vself.totalfin * 100 : 0},
                        {value: parseFloat(response.data.recebido), name: 'RECEBIDOS',  media : parseFloat(response.data.recebido) > 0 ? parseFloat(response.data.recebido) / vself.totalfin * 100 : 0},                        
                        {value: parseFloat(response.data.apagar),   name: 'À PAGAR',    media : parseFloat(response.data.apagar) > 0 ? parseFloat(response.data.apagar) / vself.totalfin * 100 : 0},
                        {value: parseFloat(response.data.pago),     name: 'PAGOS',      media : parseFloat(response.data.pago) > 0 ? parseFloat(response.data.pago) / vself.totalfin * 100 : 0}                   
                    ];


                    ///pedcompra pie 
                    vself.totalpedcompra = parseFloat(response.data.digitacao) + parseFloat(response.data.aguardando) + parseFloat(response.data.entregue) + parseFloat(response.data.cancelado);
                    vself.dadospedcompra = [
                        {value: parseFloat(response.data.digitacao), name: 'EM DIGITAÇÃO',  media : parseFloat(response.data.digitacao) > 0 ? parseFloat(response.data.digitacao) / vself.totalpedcompra * 100 : 0},
                        {value: parseFloat(response.data.aguardando), name: 'AGUARDANDO',  media : parseFloat(response.data.aguardando) > 0 ? parseFloat(response.data.aguardando) / vself.totalpedcompra * 100 : 0},                        
                        {value: parseFloat(response.data.entregue),   name: 'ENTREGUE',    media : parseFloat(response.data.entregue) > 0 ? parseFloat(response.data.entregue) / vself.totalpedcompra * 100 : 0},
                        {value: parseFloat(response.data.cancelado),  name: 'CANCELADO',      media : parseFloat(response.data.cancelado) > 0 ? parseFloat(response.data.cancelado) / vself.totalpedcompra * 100 : 0}                   
                    ];
                    ///fim

                    
                    let dadosvendedorestemp    = response.data.vendedores;
                    vself.dadosvendedores = [];
                    for (let i = 0; i < dadosvendedorestemp.length; i++){
                        let element = dadosvendedorestemp[i];
                        let elementValue = parseFloat(dadosvendedorestemp[i].value);

                        if (elementValue < 0){
                            continue;
                        }
                        else{
                            vself.dadosvendedores.push(element);
                        }
                    }

                    vself.legendasfinanceiro = util.gerardadoslegendagrafico(vself.dadosfinanceiro);
                    vself.legendasvendedores = util.gerardadoslegendagrafico(vself.dadosvendedores);
                    vself.legendapedcompra   = util.gerardadoslegendagrafico(vself.dadospedcompra);
                    vself.mediafaturamento   = vself.mtdmediafaturados();
                    let mesini = vself.pdtini.substring(3,5);
                    let mesfim = vself.pdtfim.substring(3,5);
                    let anoini = vself.pdtini.substring(6,10);
                    let anofim = vself.pdtfim.substring(6,10);
                    if ((parseInt(mesini) === parseInt(mesfim)) && (parseInt(anoini) === parseInt(anofim))){
                        vself.displayperiodo = vself.pdtini.substring(0, 2) + ' - ' + vself.pdtfim.substring(0, 2) + ' ' + vself.mtdmesextenso(vself.pdtini.substring(3,5)) + ' ' + vself.pdtini.substring(6, 10);
                    }else{
                        vself.displayperiodo = vself.pdtini +' à '+vself.pdtfim;
                    }
                    if(parseInt(vself.usuariologado.cardpicovendas) === 1){
                        vself.mtdmostrapicovendas(response.data.picovendas, util.diasemanaintmysql());
                    }
                    //loader.hide();	
                    vself.isloading = false;										
                }).catch(function (response) {
                    vself.lstresultadofaturamento = [];
                    //loader.hide();
                    vself.isloading = false;	
                });                
            },
            mtdmudatop5(){
                this.visualizartop5 = parseInt(this.visualizartop5) === 0 ? 1 : 0;
                this.lsttop5pro     = parseInt(this.visualizartop5) === 0 ? this.lsttop5provl : this.lsttop5proqtd;
            },
            mtdnovatarefa(){
                this.optarefa = 0;
                this.idtarefa = 0;
                let payload = {
                    abrirtela    : true			
                };
                this.$store.commit('ROTINA_TAREFAS_CHANGE',payload);
            },
            mtdgerenciartarefa(idtarefa){
                this.optarefa = 1;
                this.idtarefa = idtarefa;
                let payload = {
                    abrirtela    : true			
                };
                this.$store.commit('ROTINA_TAREFAS_CHANGE',payload);                
            },
            mtdpicosvenda(diasemana){
                var vself           = this;
                let loader          = vself.$loading.show();
                let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                let parametros      = [
                    {parametro: 'idclientesac', valor  : window.localStorage.getItem('idcliente')},                    
                    {parametro: 'op',           valor : 'picovendas'},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                    
                    {parametro: 'periodo',      valor : periodo},
                    {parametro: 'diasemana',    valor : diasemana}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
                retorno.then(function (response) {
                    loader.hide();							
                    vself.mtdmostrapicovendas(response.data.picovendas, diasemana);                                       				                    
                }).catch(function (response) {
                    loader.hide();
                });                                
            },
            mtdmostrapicovendas(picovendas, diasemana){
                let vself = this;
                vself.diaselecionado = diasemana;
                vself.mtdhoramaiorquantidade(picovendas);
                vself.agrupamentohoras          = [];                            
                vself.agrupamentoquantidades    = [];                                        				
                let agr1 = [];
                let agr2 = [];
                if (picovendas.length > 0){
                    for (let i = 0; i < picovendas.length; i++) {
                        picovendas[i];
                        agr1.push(picovendas[i].hora+':00');                            
                        agr2.push(picovendas[i].quantidade);
                    }
                }
                vself.agrupamentohoras          = agr1;                            
                vself.agrupamentoquantidades    = agr2;                
            },
            mtdhoramaiorquantidade(arr) {            
                let maiorQuantidade = 0;
                let horaMaiorQuantidade = "";

                for (let i = 0; i < arr.length; i++) {
                    const quantidade = parseInt(arr[i].quantidade);
                    if (quantidade > maiorQuantidade) {
                    maiorQuantidade = quantidade;
                    horaMaiorQuantidade = arr[i].hora;
                    }
                }
                this.hrmaior = horaMaiorQuantidade;
                // o código seguinte pega tanto a maior quanto a menor
                // let arrt = JSON.parse(JSON.stringify(arr));
                // arrt.sort(function(a, b) {
                //     var quantidadeA = parseInt(a.quantidade);
                //     var quantidadeB = parseInt(b.quantidade);
                    
                //     if (quantidadeA < quantidadeB) {
                //         return 1;
                //     } else if (quantidadeA > quantidadeB) {
                //         return -1;
                //     } else {
                //         return 0;
                //     }
                // });
                // this.hrmaior = arr[0].hora;                
                // this.hrmenor = arr[arr.length - 1].hora;
            },
            mtdmetasvendedores(){
                var vself           = this;
                if (parseInt(vself.utodasfiliais) === 0 && vself.idfilialmeta !== null){
                    vself.$toastr.i('Informe uma filial para consulta', 'Informação!');
                }else{
                    let loader          = vself.$loading.show();
                    let parametros      = [
                        {parametro: 'idclientesac', valor  : window.localStorage.getItem('idcliente')},                    
                        {parametro: 'op',           valor : 'metavendas'},
                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                    
                        {parametro: 'mes',          valor : vself.mesmeta},
                        {parametro: 'ano',          valor : vself.anometa},
                        {parametro: 'idfilial',     valor : vself.idfilialmeta === null ? 0 : vself.idfilialmeta},

                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
                    retorno.then(function (response) {
                        loader.hide();							
                        vself.dadosmetas = response.data.metasvendas;
                        vself.mtdmontagraficometas();                                       				                    
                    }).catch(function (response) {
                        loader.hide();
                    });   
                }              
            },
            mtdmontagraficometas(){
                let vself = this;
                vself.totalgeralvendasmetas = 0;
                vself.totalgeralmeta        = 0;
                vself.gruponomes = [];
                vself.series     = [];
                let gpn          = [];
                for (let i = 0; i < vself.dadosmetas.length; i++) {
                    gpn.push(vself.dadosmetas[i].nome);
                }
                let vnd = [];
                for (let i = 0; i < vself.dadosmetas.length; i++) {
                    vnd.push(parseFloat(vself.dadosmetas[i].totalvendas));
                    vself.totalgeralvendasmetas = vself.totalgeralvendasmetas + parseFloat(vself.dadosmetas[i].totalvendas);
                }

                let mt = [];
                for (let i = 0; i < vself.dadosmetas.length; i++) {
                    mt.push(parseFloat(vself.dadosmetas[i].totalmeta));
                    vself.totalgeralmeta = vself.totalgeralmeta + parseFloat(vself.dadosmetas[i].totalmeta);
                }

                let series = [
                    {
                        name: 'Vendas',
                        type: 'bar',
                        data: vnd
                    },
                    {
                        name: 'Metas',
                        type: 'bar',
                        data: mt
                    }
                ];
                vself.series     = series;                                
                vself.gruponomes = gpn;
            },

            // - Método para exibir a margem de lucro geral
            mtdmargemlucrogeral() {
                var vself = this;
                if (parseInt(vself.utodasfiliais) === 0 && vself.idfilialmeta !== null){
                    vself.$toastr.i('Informe uma filial para consulta', 'Informação!');
                } else{
                    // let loader = vself.$loading.show();
                    
                    // let parametros = [
                    //     {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},                    
                    //     {parametro: 'op',           valor : 'margemlucrogeral'},
                    //     {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    // ];
                    
                    // let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
                    // retorno.then(function (response) {
                    //     const margemlucrogeral = response.data[0].margemlucrogeral;
                    //     // console.log(margemlucrogeral);
                    //     vself.margemlucrogeral = margemlucrogeral;

                    //     loader.hide();							                           				                    
                    // }).catch(function (response) {
                    //     loader.hide();
                    // });  
                    
                    // console.log(vself.lstresultadofaturamento[0]);

                    const totalpedidos = vself.lstresultadofaturamento[0].totalpedidos;
                    const totalcustos  = vself.lstresultadofaturamento[0].totalcusto;
                    vself.margemlucrogeral  = 0;
                    vself.margemlucrogeral  = vself.mtdformatavalordecimal(parseFloat(((totalpedidos - totalcustos) / totalcustos) * 100));
                }
            }
        },
        mounted: function () {  
            let vself = this;      
            
            vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;
            let sqliniusuario   = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
			let sqlfimusuario   = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                

            $('#mddefinirperiododash').on('shown.bs.modal', function () {
                $('#eddtini').focus();
                $('#cbfilial').val(null).trigger('change');
            }); 
            $('#sbsituacaotarefas').selectpicker({
                noneResultsText : 'Sem resultados',
                noneSelectedText: 'Nenhuma selecionada',
                selectAllText   : 'Todas',
                deselectAllText : 'Nenhuma'
            });

            //$('#sbsituacaotarefas').selectpicker('selectAll');//Seleciona todas as tarefas                       
            $('#sbsituacaotarefas').selectpicker('val', ['0', '2']);//Seleciona apenas as em dia e as atrasadas
            util.atzverificalib(this, true);
           
           if (this.usuariologado.id !== null){
                this.mtdresultadofaturamento(); 
           } 
            
            $("#cbfilialmetas").select2({
                id: function (e) {return e.codfil},
                ajax: {						
                    url: vself.$store.state.configpaths.pathselect2sql,						
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q		: params.term,
                            idclientesac : vself.$store.state.filialpadrao.idcliente,
                            sqlini	: sqliniusuario,
                            sqlfim	: sqlfimusuario,
                            cpid	: 'codfil',
                            cpdesc	: 'fantasia'
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
			}).change(function () {
				vself.idfilialmeta = $("#cbfilialmetas").val();
			});

            $("#cbfilial").select2({
                multiple: true, // Permite múltiplas seleções
                placeholder: 'Selecione 1 ou mais filiais',
                allowClear: true,
                id: function (e) {return e.codfil},
                ajax: {						
                    url: vself.$store.state.configpaths.pathselect2sql,						
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q		: params.term,
                            idclientesac : vself.$store.state.filialpadrao.idcliente,
                            sqlini	: sqliniusuario,
                            sqlfim	: sqlfimusuario,
                            cpid	: 'codfil',
                            cpdesc	: 'fantasia'
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
            }).change(function () {
                vself.lstfiliais = $("#cbfilial").val();
            });

            let dataatual  = new Date();
            let anoatual   = dataatual.getFullYear();

            this.anometa   = parseInt(anoatual);
            this.mesmeta   = parseInt(dataatual.getMonth()) + 1;             

            this.anoslistameta = [];

            for (let index = 0; index < 20; index++) {// cria uma lista de anos a partir da data atual - guga
                anoatual = index === 0 ? parseInt(anoatual) : parseInt(anoatual) + 1;
                let anox = {
                    'ano' : anoatual
                };
                this.anoslistameta.push(anox);
            }
            if (parseInt(vself.usuariologado.cardmetas) === 1){
                setTimeout(() => {
                    vself.mtdmetasvendedores();
                }, 200);					            
            }

            // - Chamando a função que exibe a margem de lucro geral
            // vself.mtdmargemlucrogeral();
            // - Executa a verificação de permissão de visualizar dados do vendedor padrão
            // this.mtdpermissaovendedorpadraometas();
        },
        computed:{
            telatarefa(){//variável para verificar se o usuário fechou o modal das tarefas
                return this.$store.state.rotinatarefas.abrirtela;                
            },
            usuariologado(){
                return this.$store.state.usuario;
            }              
        },
    watch:{
        telatarefa(val){//atualiza os dados da dashboard quando o usuário fecha a tela da tarefa
            if (!val){
                this.mtdresultadofaturamento();
            }               
        },
        usuariologado(){
            this.mtdresultadofaturamento();
        }
    }        
}
</script>
<style>
    .card-dash{
        height: 45px;
        padding: 10px 15px!important;
        background: white!important;
        border-bottom: 1px solid #00000020!important;        
    }
    .tit-card-dash{
        color: #666666!important;
        font-weight: 500!important;        
    }
    .li-item-card-dash{
        list-style-type: none;
    }
    .txt-item-card-dash{
        font-size: 12px;
        color: #666666;
        font-weight: 700;
    }
    .txt-item-card-dash-grafico{
        font-size: 10px;
        color: #666666;
        font-weight: 600;        
    }
    .txt-item-card-dash-top5-desc{
        font-size: 10px;
        color: #666666;
        font-weight: 600; 
        max-width: 280px!important; 
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;                
    }   
    .txt-item-card-dash-top5-val{
        font-size: 10px;
        color: #666666;
        font-weight: 600;        
    }    
    .txt-item-card-dash-top10-desc{
        font-size: 10px;
        color: #666666;
        font-weight: 600; 
        max-width: 280px!important; 
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;                
    }   
    .txt-item-card-dash-top10-val{
        font-size: 10px;
        color: #666666;
        font-weight: 600;        
    }    
    .btn-muda-top5{
        margin-right: 5px!important;
        font-size: 10px!important;
        width: 20px!important;
        height: 20px!important;
        padding: 2px!important;
        margin-top: -5px!important;        
    }
    .card-tarefas{
        min-height: 154px!important;
        /* background: #727cf5!important; */
        background-image: linear-gradient(to right, #19218b, #2029a2, #2731b9, #2e3ad1, #3543e9);
        
        border-radius: 15px!important;
    }
    .pb-tarefa{
        background: #727cf5!important;
        font-size: 10px!important;
    }
    .bgd-st-tarefa{
        width: 73px;
    }
    .btn-light{
        background: #fbfbfb!important;
    }   
    .dia-selecionado{
        border-bottom: 4px solid #0acf97!important;
    } 
    @media (max-width: 344px) {
        .valconainer{
            padding: 0 !important;
        }      
    }  
    @media (max-width: 576px) {
        .grafico-metavendedores .echarts {
            width: 300px;
            height: 100px;
        }        
    }  
    @media (min-width: 577px) {
        .grafico-metavendedores .echarts {
            width: 500px;
            height: 300px;
        }        
    }  
    @media (min-width: 1024px) {
        .grafico-metavendedores .echarts {
            width: 1024px;
            height: 400px;
        }       
    }  
    @media (min-width: 1257px) {
        .notasalert{
            left: 178px;
             top: 29px;
        }
    }  
    @media (min-width: 1200px) {
        .notasalert{
            left: 170px;
             top: 29px;
        }
    }  
    @media (min-width: 1001px) {
        .notasalert{
            position: absolute;
            left: 170px;
             top: 29px;
        }
        .popover-arrow {
            position: absolute;
            top: -10px; /* Posiciona a seta acima do popover */
            left: 168px !important; /* Centraliza a seta abaixo do ícone */
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 10px solid #f8f9fa; /* Cor da seta, combinando com o fundo do popover */
          }
    }  
    .notasalert {
         animation: piscar 1s infinite;
         color: red;
    }
    @keyframes piscar {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
        100% {
            opacity: 1;
        }
    }
    .popover-container {
        position: absolute;
        top: 60px; /* Ajusta a posição do popover */
        left: 0;
        background-color: #f8f9fa;
        padding: 10px;
        border-radius: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        z-index: 1000;
        width: 200px; /* Ajuste de largura */
      }
      
      /* Seta do popover */
      .popover-arrow {
        position: absolute;
        top: -10px; /* Posiciona a seta acima do popover */
        left: 20px; /* Centraliza a seta abaixo do ícone */
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #f8f9fa; /* Cor da seta, combinando com o fundo do popover */
      }
      
      /* Conteúdo do popover */
      .popover-content {
        position: relative;
        z-index: 1; /* Garante que o conteúdo fique acima da seta */
      }
</style>